import { Feature } from "ol";
import { Point } from "ol/geom";
import { fromLonLat } from "ol/proj";
import Fill from "ol/style/Fill";
import Icon from "ol/style/Icon";
import Stroke from "ol/style/Stroke";
import Style from "ol/style/Style";
import Text from "ol/style/Text";
import BaseFeature from "./base.feature";
import IDeviceStore from "@/models/modelStore/IDeviceStore";

export default class DeviceFeature extends BaseFeature {

    device: IDeviceStore
    constructor(device: IDeviceStore) {
        super();
        this.device = device
    }

    getFeature() {
        const position = this.device.position
        return new Feature({
            geometry: new Point(fromLonLat([position?.longitude || 0, position?.latitude || 0])), //recoge las coordenadas de ubicacion
            type: 'device',
            device: this.device
        })
    }

    getStyle(): Style {
        return new Style({
            image: new Icon(({
                anchor: [0.5, 0.5],
                scale: 0.45,
                anchorXUnits: 'fraction',
                anchorYUnits: 'fraction',
                crossOrigin: 'anonymous',
                src: require("@/assets/img/devices/" + (this.device.icon || '0') + ".png")
            })),
            text: new Text({
                font: 'bold 18px Changa',
                overflow: true,
                text: this.device.name,
                fill: new Fill({
                    color: '#001FD3'
                }),
                stroke: new Stroke({
                    color: '#fff',
                    width: 2
                }),
                offsetY: 28,
                scale: 1
            })
        })
    }

    isValid(): boolean {
        return !!this.device?.position
    }

}